module.exports = __webpack_public_path__ + "img/pic_2_zh_new.48755685.png";